import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { loginUserApi , loginGuestUser } from "../helper/authentication";
import { toast } from "react-toastify";
import { skipUser } from "../helper/authentication";
import { getUser } from "../action/authActions";
import CustomTextField from "./CustomTextField";
import BrandWordmark from "../component/users/BrandWordmark";

const errorTextStyle = {
  backgroundColor: "#00000075",
  color: "red",
  padding: "5px",
  borderRadius: "5px",
};

function getSafeRedirect(raw) {
  if (!raw || typeof raw !== "string") return null;
  const path = raw.trim();
  if (!path.startsWith("/") || path.startsWith("//")) return null;
  return path;
}

function isBuyVotesRedirect(path) {
  return Boolean(path && path.includes("buyVotes=1"));
}

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const authState = useSelector((state) => state.auth);
  const [showPass, setShowPass] = useState(false);
  const [showConfPass, setShowConfPass] = useState(false);
  const { loginUser } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = getSafeRedirect(searchParams.get("redirect"));
  const handleClickShowPassword = () => setShowPass((show) => !show);
  const handleClickShowConfPassword = () => setShowConfPass((show) => !show);
  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const handleMouseDownConfPassword = (e) => {
    e.preventDefault();
  };

  // const handleSkip = async () => {
  //   try {
  //     setLoading(true);
  //     const data = await skipUser();
  //     if (!data?.skipRegister) {
  //       toast.error(data.message);
  //       return;
  //     }
  //     dispatch({ type: "SAVE_LOGGED_USER", payload: { is_skip: true } });
  //     dispatch(getUser("", "is_skip"));
  //     loginUser(data?.skipRegister);
  //     navigate(`/`);
  //   } catch (error) {
  //     toast.error(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };




    const handleSkip = async () => {
      // "";
      try {
        setLoading(true);
        const deviceId = localStorage.getItem("mynetgoals.com-device-id");
        const data = await loginGuestUser(deviceId);
        if (!data?.token) {
          toast.error(data.message);
          return;
        }
        dispatch({ type: "SAVE_LOGGED_USER", payload: { ...data?.data } });
        localStorage.setItem("mynetgoals.com-userData", JSON.stringify(data?.data));
        // dispatch(getUser("", "is_skip"));
        loginUser(data?.token);

        if (isBuyVotesRedirect(redirectTo)) {
          toast.info("Please register or log in to purchase votes.");
          navigate(`/`);
        } else {
          navigate(redirectTo || `/`);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };



  useEffect(() => {
    if (user != null) {
      dispatch({ type: "SAVE_LOGGED_USER", payload: user?.data });
      dispatch(getUser(user?.token, user?.data?.id));
      loginUser(user?.token);
      navigate(redirectTo || `/`);
    }
  }, [user, redirectTo, dispatch, loginUser, navigate]);


  // useEffect(() => {
  //   if (authState.isAuthenticated) {
  //     navigate("/");
  //   }
  // }, [authState]);

  const registerForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter valid email address")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: async (values, action) => {
      try {
        setLoading(true);

        const data = await loginUserApi(values);
        if (!data?.token) {
          toast.error(data.message);
          return;
        }
        // Clear any previous guest trial data so Home doesn't false-trigger
        localStorage.removeItem("mynetgoals.com-userData");
        setUser(data);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
        // onClick={}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <Container>

      </Container> */}
      <Box className="RegisterDiv">
        <Box className="skip_option">
          <Box className="skip">
            <Button onClick={handleSkip}>
              Guest Login
              <ArrowForwardIosIcon className="ficon" />
            </Button>
          </Box>
        </Box>
        <Box className="form_wrapper">
          <Box className="form_inner">
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <BrandWordmark />
            </Box>
            <Typography component="h2" className="form_head">
              Welcome Back
            </Typography>
            <Typography component="p" className="form_sub_head">
              Please enter the details to continue.
            </Typography>
            <form onSubmit={registerForm.handleSubmit} autoComplete="off">
              <Box className="form">
                <CustomTextField
                  id="outlined-basic"
                  // label="Outlined"
                  name="email"
                  variant="outlined"
                  className="register_field"
                  placeholder="Email"
                  value={registerForm.values.email}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.email &&
                    Boolean(registerForm.errors.email)
                  }
                  helperText={
                    registerForm.touched.email &&
                    Boolean(registerForm.errors.email) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.email}
                      </span>
                    )
                  }
                  // autoComplete="off"
                  inputProps={{
                    autoComplete: "none",
                  }}
                />
                <CustomTextField
                  id="outlined-start-adornment"
                  // label="Outlined"
                  name="password"
                  variant="outlined"
                  className="register_field"
                  placeholder="Password"
                  type={showPass ? "text" : "password"}
                  value={registerForm.values.password}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.password &&
                    Boolean(registerForm.errors.password)
                  }
                  helperText={
                    registerForm.touched.password &&
                    Boolean(registerForm.errors.password) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.password}
                      </span>
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPass ? (
                            <Visibility sx={{ color: "white" }} />
                          ) : (
                            <VisibilityOff sx={{ color: "white" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                />

                <Button
                  className="Register"
                  type="submit"
                  sx={{ textTransform: "none !important" }}
                >
                  Login
                </Button>
              </Box>
            </form>
            <Box
              className="add-navi"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Box>
                <Typography
                  component="span"
                  onClick={() => navigate("/forgotPassword")}
                  sx={{
                    cursor: "pointer",
                    textDecoration: "none !important",
                    "&:hover": {
                      textDecoration: "underline !important",
                    },
                  }}
                >
                  Forgot your password ?
                </Typography>
              </Box>

              <Box>
                <Typography
                  component="span"
                  onClick={() => navigate("/register")}
                >
                  Don't have an account ?{" "}
                  <a
                    style={{
                      textDecoration: "none !important",
                      // "&:hover": {
                      //   textDecoration: "underline",
                      // },
                    }}
                  >
                    Sign up now
                  </a>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
